import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { updateCartItemQuantity } from "../../utils/cartSync"; // adjust path if needed

const CompactQuantitySelector = ({
  quantity,
  onChange,
  itemsPerSet = 1,
  item,
  sync = false,
}) => {
  const handleUpdate = async (newQty) => {
    onChange(newQty);

    if (sync && item) {
      try {
        await updateCartItemQuantity(item, newQty);
      } catch (err) {
        console.warn("❌ Failed to sync quantity change");
      }
    }
  };

  const handleDecrement = () => {
    if (quantity > itemsPerSet) {
      handleUpdate(quantity - 1);
    }
  };

  const handleIncrement = () => {
    handleUpdate(quantity + 1);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        mt: 1,
      }}>
      <IconButton
        size="small"
        onClick={handleDecrement}
        disabled={quantity <= itemsPerSet}>
        <RemoveIcon fontSize="small" />
      </IconButton>

      <Typography fontWeight="bold">{quantity}</Typography>

      <IconButton size="small" onClick={handleIncrement}>
        <AddIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default CompactQuantitySelector;
